<template>
    <div class="text-center">
        <v-menu
            v-model="account"
            :close-on-content-click="false"
            nudge-width="100"
        >
            <template #activator="{ on }">
                <v-btn
                    text
                    depressed v-on="on"
                >
                    <span class="mr-2">
                        {{ $t(`role.${$auth.user().role}`) }} -
                        {{ $auth.user().firstname }}
                        {{ $auth.user().lastname }}
                    </span>
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-list class="info-perso">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $auth.user().firstname }}
                                {{ $auth.user().lastname }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ $auth.user().email }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list class="info-etp">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{
                                    $t("profile.role")
                                }}
                            </v-list-item-subtitle>
                            <v-list-item-title>
                                {{ $t(`role.${$auth.user().role}`) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list class="info-action">
                    <v-list-item @click="showDialog = true ">
                        <v-list-item-title>{{
                                $t("profile.update_password")
                            }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-list-item-title>{{
                                $t("login.logout")
                            }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <reset-password :visible="showDialog" @close="handleClose"/>
    </div>
</template>

<script>
import resetPassword from './dialogs/resetPassword'

export default {
    name: "Account",
    components: {
        resetPassword
    },
    data: () => ({
        showDialog: false,
        fav: true,
        account: false,
        message: false,
        hints: true,
    }),
    methods: {
        logout() {
            this.$auth.logout()
        },
        handleClose() {
            this.showDialog = false
        },
    },
};
</script>
